import { Component, Input, OnInit } from '@angular/core';
import { Gloss } from '@models/Gloss';
import { Verse } from '@models/Verse';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { GlossSelectorLineComponent } from '../gloss-selector-line/gloss-selector-line.component';
import { GlossDialogOutput } from '../gloss-dialog/gloss-dialog.component';
import { SynchronizerService } from '../../synchronizer.service';
import { ApiService } from '../../api.service';

@Component({
  selector: 'app-phrase-gloss-display',
  imports: [CommonModule, MatCardModule, GlossSelectorLineComponent],
  templateUrl: './phrase-gloss-display.component.html',
  styleUrl: './phrase-gloss-display.component.scss'
})
export class PhraseGlossDisplayComponent implements OnInit {
  @Input() verse!: Verse;
  @Input() glosses!: Gloss[];

  constructor(private synchronizerService: SynchronizerService,
    private api: ApiService) {
  }

  ngOnInit() {
  }


  public processGlossAction(action: GlossDialogOutput) {
    if (action.action === 'delete') {
      this.deleteGloss(action.gloss);
    } else if (action.action === 'edit') {
      this.editGloss(action.gloss);
    }
  }

  async deleteGloss(gloss: Gloss) {
    /// if gloss_id is -1, it means this is a new gloss that has not been saved to the server yet
    if (gloss.gloss_id !== -1) {
      /// save whatever existing data there are
      await this.synchronizerService.saveVerseData();
      /// remove the gloss from the server
      await this.api.removePhraseGloss(gloss.gloss_id);
      /// get the verse data from the server again
      this.synchronizerService.forceVerseReloadWithoutSendingData();
    }
  }

  async editGloss(gloss: Gloss) {
    /// if gloss_id is -1, it means this is a new gloss that has not been saved to the server yet
    if (gloss.gloss_id !== -1) {
      /// save whatever existing data there are
      await this.synchronizerService.saveVerseData();
      /// remove the gloss from the server
      await this.api.editPhraseGloss(gloss);
      /// get the verse data from the server again
      this.synchronizerService.forceVerseReloadWithoutSendingData();
    }
  }

}
